import { State, Action, StateContext, Store } from '@ngxs/store';
import { SubscribeToBorrowerChats, GetBorrowerChats, ClearChatStore } from './chat.actions';
import {catchError, tap} from 'rxjs/operators';
import { Chat } from '../chat-service/chat.model';
import { ChatService } from '../chat-service/chat.service';
import { PusherService } from 'app/modules/shared/services/pusher.service';
import { Injectable } from '@angular/core';
import {of} from 'rxjs';

export class ChatStateModel {
    chats: Chat[];
}

@State<ChatStateModel>({
    name: 'chats',
    defaults: {
        chats: []
    }
})

@Injectable()
export class ChatState {

    constructor(
        private chatService: ChatService,
        private pusherService: PusherService,
        private store: Store
    ) {}

    @Action(GetBorrowerChats)
    getBorrowerChats({ patchState }: StateContext<ChatStateModel>, { borrowerId }: GetBorrowerChats) {
        return this.chatService.getBorrowerChats(borrowerId)
          .pipe(
            tap(chats => {
              patchState({ chats });
            }),
            catchError( error => {
              console.error(error);
              return of();
            }),
          );
    }

    @Action(SubscribeToBorrowerChats)
    subscribeToBorrowerChats(_: StateContext<ChatStateModel>, { borrowerId }: SubscribeToBorrowerChats) {
        this.pusherSubscribe(borrowerId);
        this.store.dispatch(new GetBorrowerChats(borrowerId));
    }

    @Action(ClearChatStore)
    clearChatStore({ patchState }: StateContext<ChatStateModel>, { borrowerId }: ClearChatStore) {
        this.pusherUnsubscribe(borrowerId);
        patchState({ chats: [] });
    }

    pusherSubscribe(borrowerId: number) {
        this.pusherService
            .subscribe(`private-borrower-${borrowerId}-chats`)
            .bind_global(this.handlePusherEvent.bind(this, borrowerId));
    }

    handlePusherEvent(borrowerId: number, eventName: string) {
        if (eventName.startsWith('chat-')) {
            this.store.dispatch(new GetBorrowerChats(borrowerId));
        }
    }

    pusherUnsubscribe(borrowerId: number) {
        this.pusherService.unsubscribe(`private-borrower-${borrowerId}-chats`);
    }
}
